<template>
	<div
		class="relative flex h-[40px] w-full items-center bg-white"
		:class="[
			divideGroups ? 'justify-center' : 'justify-start',
			border && 'border-b border-[#E9EEF2]'
		]"
	>
		<div
			class="hidden items-center md:flex"
			:class="divide ? 'left-0 space-x-2 divide-x divide-[#DBDBDC] md:absolute' : ''"
		>
			<pdf-undo-redo class="pl-4" />
			<pdf-perspective
				v-if="compact === false"
				class="pl-2"
			/>
			<pdf-pagination
				v-if="compact === false"
				:key="numberOfPages"
				class="pl-2"
				:current-page="currentPage"
				:nr-of-pages="numberOfPages"
				@move-up="() => scrollToPage(currentPage-1)"
				@move-down="() => scrollToPage(currentPage+1)"
			/>
		</div>

		<div
			id="onboarding-builder-style-builder"
			data-step="5"
			class="flex items-center"
		>
			<PdfFontType v-if="compact === false" />
			<Divider />
			<pdf-text-size />
			<Divider />
			<div class="relative flex items-center justify-center">
				<pdf-formatting />
			</div>
			<Divider />
			<pdf-hyperlink />
			<Divider />
			<pdf-line-height v-if="compact === false" />
			<Divider />
			<Indentation />
			<Divider />
			<EditMargins />
			<pdf-reset-margins
				v-if="compact === false"
				class="pl-2"
			/>
			<pdf-reset-cover-letter
				v-if="isOnCoverLetterEditor"
				@click="regenerateCoverLetterPrompt"
			/>
			<pdf-change-template
				v-if="!isOnCoverLetterEditor && templates.length"
				@click="changePDFTemplate"
			/>
		</div>
        
		<pdf-regenerate-section
			v-if="isOnCoverLetterEditor"
			@regenerate="regenerateCoverLetter"
		/>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import PdfFontType from './pdf-fonttype.vue';
import PdfHyperlink from './pdf-hyperlink.vue';
import PdfPerspective from './pdf-perspective.vue';
import PdfPagination from './pdf-pagination.vue';
import PdfLineHeight from './pdf-line-height.vue';
import Indentation from './indent.vue';
import PdfFormatting from './pdf-formatting.vue';
import PdfUndoRedo from './pdf-undo-redo.vue';
import PdfRegenerateSection from './pdf-regenerate-section.vue';
import PdfTextSize from './pdf-text-size.vue';
import PdfChangeTemplate from './pdf-change-template.vue';
import PdfResetMargins from './pdf-reset-margins.vue';
import PdfResetCoverLetter from './pdf-reset-cover-letter.vue';
import EditMargins from './components/editor-top-bar/margins.vue';

import Divider from '../library/divider.vue';

const emit = defineEmits(['regenerate', 'change-page', 'regenerate-cover-letter-prompt', 'change-template']);
const props = defineProps({
	isOnCoverLetterEditor: {
		type: Boolean,
		default: false
	},
	numberOfPages: {
		type: Number,
		default: 0
	},
	currentPage: {
		type: Number,
		default: 0
	},
	templates: {
		type: Array,
		default() {
			return [];
		}
	},
	divide: {
		type: Boolean,
		default: true
	},
	divideGroups: {
		type: Boolean,
		default: true
	},
	compact: {
		type: Boolean,
		default: false
	},
	border: {
		type: Boolean,
		default: true
	}
});

const route = useRoute();

const isOnCoverLetterEditor = computed(() => {
	return route.meta?.coverLetter || false;
});

const changePDFTemplate = () => {
	emit('change-template');
};

const regenerateCoverLetterPrompt = () => {
	emit('regenerate-cover-letter-prompt');
};

const regenerateCoverLetter = (allText) => {
	emit('regenerate', allText);
};

const scrollToPage = (page) => {
	emit('change-page', page);
};
</script>
